module.exports = __webpack_public_path__ + "img/2019-min.cdd6b623.jpg";